/**
 * @desc: 手续费利润
 * @created: 2020/09/09
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T6/profitFee'

export default {
  namespaced: true,
  state: {
    parameter: {}
  },
  getters: {
    parameter: state => state.parameter,
  },
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },
    getDetailList(ctx, payload) {
      return Models.getDetailList(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },
    getPaymentDetails(ctx, payload) {
      return Models.getPaymentDetails(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
    // 余额交易利润
    getBalanceListData(ctx, payload) {
      return Models.getBalanceListData(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },
  },
  mutations: {
    setParameter: (state, data) => {
      state.parameter = data
    }
  }
}
